import { ArrowLeft, Calendar, Clock, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import { getStatusBadgeVariant } from '@/lib/badge';
import { formatDate } from '@/lib/date';

import type { BatchCallDetail } from '@/types/scheduler.type';

type Props = {
  batchCall: BatchCallDetail;
};

export function BatchCallDetailHeader({ batchCall }: Props) {
  const navigate = useNavigate();

  return (
    <div className="flex items-start justify-between gap-6">
      <div className="flex items-start gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/batch-calls')}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-semibold text-foreground">{batchCall.batchName}</h1>
            <Badge variant={getStatusBadgeVariant(batchCall.status)} className="text-sm">
              {batchCall.status}
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground mt-1">
            Batch call details and recipient status
          </p>
        </div>
      </div>

      <div className="flex items-start gap-4 text-sm">
        <div className="flex items-center gap-1.5">
          <Phone className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">{batchCall.agent.phoneNumber}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Calendar className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">{formatDate(batchCall.scheduledTime)}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Clock className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">{formatDate(batchCall.scheduledTime)}</span>
        </div>
      </div>
    </div>
  );
}
